import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { apiJson } from '../lib/api.js';

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [status, setStatus] = useState({ kind: 'idle', message: '' });

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setStatus({ kind: 'sending' });
    try {
      await apiJson('/api/auth/resend-verification', { method: 'POST' });
      setStatus({ kind: 'sent', message: 'Verification link sent. Check your inbox (+ spam folder).' });
    } catch (e) {
      setStatus({ kind: 'error', message: e.message || 'Could not send.' });
    }
  };

  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 30,
        background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
        borderBottom: '1px solid #fcd34d',
        color: '#7c2d12',
        padding: '10px 18px',
        display: 'flex',
        gap: 14,
        alignItems: 'center',
        flexWrap: 'wrap',
        fontSize: 13.5,
      }}
    >
      <span style={{ fontSize: 16 }}>⚠️</span>
      <strong>Verify your email.</strong>
      <span style={{ flex: 1, minWidth: 220 }}>
        You're signed in but haven't confirmed your email yet — drill saves and
        admin features stay locked until you do.
      </span>
      {status.kind === 'sent' && (
        <span style={{ color: '#166534', fontWeight: 600 }}>{status.message}</span>
      )}
      {status.kind === 'error' && (
        <span style={{ color: '#991b1b', fontWeight: 600 }}>{status.message}</span>
      )}
      {status.kind !== 'sent' && (
        <button
          type="button"
          onClick={resend}
          disabled={status.kind === 'sending'}
          style={{
            background: '#7c2d12',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          {status.kind === 'sending' ? 'Sending…' : 'Resend email'}
        </button>
      )}
      <Link
        to="/verify-email"
        style={{
          color: '#7c2d12',
          fontWeight: 600,
          textDecoration: 'underline',
        }}
      >
        I have a token →
      </Link>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        style={{ background: 'transparent', border: 'none', color: '#7c2d12', cursor: 'pointer', fontSize: 16, padding: 4 }}
      >
        ×
      </button>
    </div>
  );
}
